export default __webpack_public_path__ + "static/media/Recruitmentimg.b12b54ef.png";